import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import SectionCard from "./SectionCard";
import FormikTextField from "./FormikTextField";

const Step5Review = () => {
  return (
    <>
      <SectionCard title="Instructions">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box component="ul" sx={{ pl: 3, m: 0 }}>
              <Typography component="li" sx={{ fontSize: "15px", mb: 1 }}>
                1. This evaluation form is to be used to approve suppliers in
                compliance with quality management system.
              </Typography>

              <Typography component="li" sx={{ fontSize: "15px", mb: 1 }}>
                2. The evaluation team may consist of representative (Head /
                Manager) from Quality team, Finance Team, and plant HR team.
              </Typography>

              <Typography component="li" sx={{ fontSize: "15px", mb: 1 }}>
                3. Based on the recommendation of evaluation team, Head
                Manufacturing will approve or reject the supplier / vendor.
              </Typography>

              <Typography component="li" sx={{ fontSize: "15px", mb: 1 }}>
                4. Approved vendor to be re-evaluated at the beginning of each
                calendar year.
              </Typography>

              <Typography component="li" sx={{ fontSize: "15px" }}>
                5. Copies of evaluation and approval would remain available with
                procurement manager, quality manager and Finance department.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </SectionCard>

      <SectionCard title="">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormikTextField
              multiline
              rows={4}
              label="Overall Comments and General Observations"
              name="overallComments"
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Please review your information before submitting:
            </Typography>
          </Grid>
        </Grid>
      </SectionCard>
    </>
  );
};

export default Step5Review;
